export const onRackSelectorOpen = () => {
  if (typeof google !== 'undefined')
    google.tagmanager.add({
      event: 'FA_rack_Open',
      selectedFilter: '',
    });
};

export const onRackSelectorClose = (selectedFilter) => {
  if (typeof google !== 'undefined')
    google.tagmanager.add({
      event: 'FA_rack_Close',
      selectedFilter: selectedFilter,
    });
};
